import React from 'react';
import StudioLandingPage from '../../features/studio/components/StudioLandingPage';

const StudioLandingRoute = () => {
  return <StudioLandingPage />;
};

export default StudioLandingRoute;
